import { render, staticRenderFns } from "./qr-code.vue?vue&type=template&id=024d9b0e&"
var script = {}
import style0 from "./o-icon.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports